/**
 * Commercial modules stored on Firestore `organizations.{orgId}`.
 * Prefer `productModules` (string array), e.g. `['invoicemodule', 'currencymodule']`.
 * Legacy single `productModule` still supported.
 */

export const PRODUCT_MODULE_SANCTIONS = 'sanctionsmodule';
export const PRODUCT_MODULE_INVOICE = 'invoicemodule';
export const PRODUCT_MODULE_CURRENCY = 'currencymodule';

/** @param {unknown} raw */
function normalizeModuleId(raw) {
  return String(raw ?? '').trim().toLowerCase();
}

/**
 * @param {Record<string, unknown> | string | null | undefined} orgOrModule
 * @returns {string[]}
 */
export function resolveOrgProductModules(orgOrModule) {
  if (typeof orgOrModule === 'string') {
    const single = normalizeModuleId(orgOrModule);
    if (single === PRODUCT_MODULE_SANCTIONS) return [PRODUCT_MODULE_SANCTIONS];
    return [PRODUCT_MODULE_INVOICE];
  }
  const orgData = orgOrModule || {};
  if (Array.isArray(orgData.productModules) && orgData.productModules.length > 0) {
    const mods = orgData.productModules.map(normalizeModuleId).filter(Boolean);
    if (mods.length > 0) return [...new Set(mods)];
  }
  const single = normalizeModuleId(orgData.productModule);
  if (single === PRODUCT_MODULE_SANCTIONS) return [PRODUCT_MODULE_SANCTIONS];
  return [PRODUCT_MODULE_INVOICE];
}

/** @param {Record<string, unknown> | string | null | undefined} orgOrModule */
export function normalizeOrgProductModule(orgOrModule) {
  const mods = resolveOrgProductModules(orgOrModule);
  if (mods.includes(PRODUCT_MODULE_SANCTIONS) && !mods.includes(PRODUCT_MODULE_INVOICE)) {
    return PRODUCT_MODULE_SANCTIONS;
  }
  return PRODUCT_MODULE_INVOICE;
}

/** Invoice pipeline: scanned list, upload, integrations-fed invoice checks, dashboard invoice stats. */
export function hasInvoicePipeline(orgOrModule) {
  const mods = resolveOrgProductModules(orgOrModule);
  return !mods.includes(PRODUCT_MODULE_SANCTIONS);
}

/** Currency exposure dashboard + foreign-currency invoice summaries. */
export function hasCurrencyModule(orgOrModule) {
  const mods = resolveOrgProductModules(orgOrModule);
  return mods.includes(PRODUCT_MODULE_CURRENCY);
}
